import React from 'react';
import firebase from '../firebaseConfig';   
import { Link} from 'react-router-dom';

class Product extends React.Component {
    constructor(){
        super();
        this.state={
            loading:true,
            products:[]
        }
    }

    componentDidMount() {
        this.timerID = setInterval(
          () => this.getData(),
          1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    getData(){
        const db = firebase.firestore();

        let data1 = [];
        db.collection('products').get().then(querySnapshot => {
        const data = querySnapshot.docs.map(doc => doc.data());
        data.forEach((doc,key)=>{
            data1.push(doc)
        })

        this.setState({products:data1, loading:false})

        });

    }

    render() {
        const {products, loading } = this.state;
      return (
          
        <div className="container mt-5">
            {loading===true&&<p>please wait . . . </p>}
        { products.map((product) => (
            <Link
                to={{ pathname: '/product/'+product.idProduct}}
                className="list-group-item"
                key={product.idProduct}>
                {product.namaProduct}
            </Link>
        ))}
      </div>
          );
        }
     }
  export default Product;
  